import { useState, useCallback } from 'react';
import { apiUtils } from '../../../utils';

/**
 * useAccountCreate - Business logic hook for account creation
 * 
 * Follows the design system principles:
 * - Pure business logic with no UI concerns
 * - Reusable across multiple components
 * - Consistent error handling and loading states
 * - Type-safe data management
 */
export const useAccountCreate = () => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	const createAccount = useCallback(async (accountData) => {
		try {
			setLoading(true);
			setError(null);

			const response = await apiUtils.post('/api/accounts', accountData);

			if (response.ok) {
				const result = await response.json();
				return { success: true, data: result.data };
			} else {
				const errorData = await response.json();
				const errorMessage = errorData.error || 'Failed to create account';
				setError(errorMessage);
				return { success: false, error: errorMessage };
			}
		} catch (err) {
			console.error('Error creating account:', err);
			const errorMessage = err.message || 'Failed to create account';
			setError(errorMessage);
			return { success: false, error: errorMessage };
		} finally {
			setLoading(false);
		}
	}, []);

	const clearError = useCallback(() => {
		setError(null);
	}, []);

	return {
		createAccount,
		loading,
		error,
		clearError
	};
}; 